<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <div class="mt-4 mb-2">
                    <b-form-group
                        label="Kilometraje"
                        description="Para tener una cotización más acertada, el kilometraje debe ser lo más aproximado posible."
                    >
                        <vue-autonumeric
                            class="form-control"
                            v-model="kilometraje"
                            :options="optionsNumeric"
                        ></vue-autonumeric>
                    </b-form-group>
                    <b-button 
                    @click="goDatos()"
                    variant="danger" class="button red mt-4" block>
                        <span>Siguiente</span>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
        ...mapFields("vender", [
            'asistente_step',
            'titulo_span',
            'selection_data.kilometraje'
        ]),
    },
    data() {
        return {
            optionsNumeric: [
                "integerPos",
                {
                    digitGroupSeparator: ".",
                    decimalCharacter: ",",
                    minimumValue: "0",
                    maximumValue: "999999"
                }
            ],
        }
    },
    methods: {
        goDatos() {
            this.asistente_step = 'datos';
            this.titulo_span = 'Ingrese sus datos de contacto';
            window.history.replaceState(null, null, '?step=7');
        }
    },
};
</script>

<style lang="scss"></style>
